/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { NavLink } from "react-router-dom";
import { useSaveSearchQuery } from "../../hooks/use-save-search-query";
import { useSearchUrl } from "../../hooks/use-search-url";

export function AllResultsLink (props) {

    const searchUrl = useSearchUrl();
    const saveSearchQuery = useSaveSearchQuery();

    return (
        <NavLink to={searchUrl} onClick={saveSearchQuery}>
            {props.children}
        </NavLink>
    );
}
